module.exports = __webpack_public_path__ + "static/media/app.1a70a8ca.png";